/**
 * Tells other RivetAI tabs that an AI app connection changed, so the
 * Connections page updates without waiting for its poll. Approval happens on
 * the consent page, usually in a tab the AI app opened, while Connections sits
 * in another tab.
 */
const CHANNEL = "rivetai:mcp-connections";
const STORAGE_KEY = "rivetai:mcp-connections-changed";

export const notifyMcpConnectionsChanged = (): void => {
  try {
    if (typeof BroadcastChannel !== "undefined") {
      const channel = new BroadcastChannel(CHANNEL);
      channel.postMessage("changed");
      channel.close();
      return;
    }
    // Fallback: a storage write fires "storage" events in other tabs.
    window.localStorage.setItem(STORAGE_KEY, String(Date.now()));
  } catch {
    // Best effort; the page still refreshes on focus and on its interval.
  }
};

export const subscribeMcpConnectionsChanged = (onChange: () => void): (() => void) => {
  if (typeof BroadcastChannel !== "undefined") {
    const channel = new BroadcastChannel(CHANNEL);
    channel.onmessage = () => onChange();
    return () => channel.close();
  }
  const onStorage = (event: StorageEvent) => {
    if (event.key === STORAGE_KEY) onChange();
  };
  window.addEventListener("storage", onStorage);
  return () => window.removeEventListener("storage", onStorage);
};
